import {
  CategoryName,
  GroupName,
  Items,
  Names,
  Wrapper,
  ToggleButton,
} from './PlanTableGroupingCell.styles.ts'
import { FC, useMemo } from 'react'
import { selectFilteredSortedPlanProducts } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import CircleMinus from '@/core/assets/icons/circle-minus.svg'
import CirclePlus from '@/core/assets/icons/circle-plus.svg'

const UNAVAILABLE_CODE = 'UNAVAILABLE'

interface Props {
  groupCode: string | null
  categoryCode: string | null
  expanded: boolean
  rowId: string
  onClick: (rowId: string) => void
}

const PlanTableGroupingCell: FC<Props> = ({
  groupCode,
  categoryCode,
  expanded,
  rowId,
  onClick,
}) => {
  const { t } = useTranslation()

  const handleClick = () => {
    onClick(rowId)
  }

  const isUnavailableGroup =
    groupCode === UNAVAILABLE_CODE && categoryCode === UNAVAILABLE_CODE

  const allProducts = useSelector(selectFilteredSortedPlanProducts)

  const products = useMemo(() => {
    if (isUnavailableGroup) {
      return allProducts.filter((product) => product.unavailable)
    }

    return allProducts.filter((product) => {
      const productGroupCode = product.group?.code ?? null
      const productCategoryCode = product.category?.code ?? null

      return (
        productGroupCode === groupCode && productCategoryCode === categoryCode
      )
    })
  }, [allProducts, groupCode, categoryCode, isUnavailableGroup])

  const groupName = isUnavailableGroup
    ? t('planTableGroupingCell.unavailable')
    : groupCode === null
      ? t('planTableGroupingCell.noGroup')
      : products[0]?.group?.name

  const categoryName = isUnavailableGroup
    ? t('planTableGroupingCell.unavailable')
    : categoryCode === null
      ? t('planTableGroupingCell.noCategory')
      : products[0]?.category?.name

  return (
    <Wrapper>
      <Names>
        <ToggleButton
          startIcon={expanded ? <CircleMinus /> : <CirclePlus />}
          onClick={handleClick}
        >
          <GroupName title={groupName} unavailable={isUnavailableGroup}>
            {groupName}
          </GroupName>
        </ToggleButton>
        {!isUnavailableGroup && (
          <CategoryName title={categoryName}>{categoryName}</CategoryName>
        )}
      </Names>
      <Items>{products.length}</Items>
    </Wrapper>
  )
}

export default PlanTableGroupingCell
